import logoUrl from "../assets/logo.jpeg";

export const APP_NAME = "Giri Nestham";
export const APP_LOGO_URL = logoUrl;

export function formatDocumentTitle(pageTitle) {
  const trimmed = pageTitle != null ? String(pageTitle).trim() : "";
  if (!trimmed || trimmed === APP_NAME) return APP_NAME;
  return `${trimmed} | ${APP_NAME}`;
}
